import { ActionIcon, Box, Group, Menu, Text } from '@mantine/core';
import { Can } from '@sportybot-web/auth/permissions/can';
import { useAuth } from '@sportybot-web/auth/useAuth';
import { CircleUserRound, Coins, LogOut, Palette } from 'lucide-react';

import { CopyTokenButton } from './copy-token-button';
import { ThemeToggle } from './theme-toggle';
import { UserInfo } from './user-info';

export function UserMenu() {
  const { authClient, user } = useAuth();

  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <ActionIcon bd="none" radius="radius-max" size="xl" variant="default">
          <CircleUserRound size={20} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Box p="space100">
          <UserInfo emailVariant="body-0" fullNameVariant="body-0-emphasis" user={user} />
        </Box>
        <Menu.Divider />
        <Group gap="space100" justify="space-between" px="space150" py="space100">
          <Group align="center" gap="space100">
            <Palette size={16} />
            <Text variant="body-1">Theme</Text>
          </Group>
          <ThemeToggle />
        </Group>

        <Can action="CAN_COPY_ACCESS_TOKEN">
          <Group gap="space100" justify="space-between" px="space150" py="space100">
            <Group align="center" gap="space100">
              <Coins size={16} />
              <Text variant="body-1">Access Token</Text>
            </Group>
            <CopyTokenButton />
          </Group>
        </Can>

        <Menu.Item leftSection={<LogOut size={16} />} onClick={() => authClient.signOut()}>
          Log out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
